import { Box } from "@mui/material";
import { CbhIcon, type CbhIconProps } from "@src/appV2/redesign/system/ui-components";

import { type PaymentsListItem } from "../types/PaymentsListItem";

export interface PaymentsListItemBadgeProps {
  item: PaymentsListItem;
}

function getIconType(item: PaymentsListItem): CbhIconProps["type"] {
  switch (item.attributes.paymentCategory) {
    case "cancellation-protection-bonus": {
      return "parachute";
    }

    case "etp-bonus":
    case "manual-bonus":
    case "other": {
      return "coin";
    }

    case "shift-cancellation": {
      return "calendar-remove";
    }

    case "worked-break": {
      return "time-flies";
    }

    case "shift-verification":
    case "shift-sent-home":
    case "shift-adjustment": {
      return "building";
    }

    default: {
      return item.attributes.paymentCategory satisfies never;
    }
  }
}

export function PaymentsListItemBadge(props: PaymentsListItemBadgeProps) {
  const iconType = getIconType(props.item);

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        width: theme.spacing(9),
        height: theme.spacing(9),
        borderRadius: theme.spacing(9),
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.palette.background.primary,
      })}
    >
      <CbhIcon data-testid={`badge-icon-${iconType}`} type={iconType} size="medium" />
    </Box>
  );
}
